import { createConfirmation } from "react-confirm";
import ProgressbarDlg from "./ProgressbarDlg";

export const showProgressbarDlg = createConfirmation(ProgressbarDlg);
